import { LOADING_PAGES, LOADING_POSTS, LOADING_MENU, LOADING_SITEINFO, LOADING_THUMBS, LOADING_CATEGORIES } from '../actions'

let defaultState = {
    loadingPages: false,
    loadingPosts: false,
    loadingMenu: true,
    loadingSiteInfo: true,
    loadingThumbs: false,
    loadingCategories: false,
}

export default function loader(state = defaultState, action) {
    switch(action.type) {
        case LOADING_PAGES:
            return Object.assign({}, state, {
                loadingPages: action.payload.loading
            })

        case LOADING_POSTS:
            return Object.assign({}, state, {
                loadingPosts: action.payload.loading
            })

        case LOADING_MENU:
            return Object.assign({}, state, {
                loadingMenu: action.payload.loading
            })

        case LOADING_SITEINFO:
            return Object.assign({}, state, {
                loadingSiteInfo: action.payload.loading
            })

        case LOADING_THUMBS:
            return Object.assign({}, state, {
                loadingThumbs: action.payload.loading
            })

        case LOADING_CATEGORIES:
            return Object.assign({}, state, {
                loadingCategories: action.payload.loading
            })

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/loader.js